import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppstoreOutlined, FileAddOutlined, FileTextOutlined, GiftOutlined } from "@ant-design/icons";
import SidebarLayout, { MenuRoute } from "./layouts/SidebarLayout";

import ProductCreatePage from "./pages/ProductCreatePage/ProductCreatePage";
import CertificateAdmin from "./pages/certificatePage/CertificateAdmin";
import PromotionAdmin from "./pages/PromotionAdmin/PromotionAdmin";
import AdminReviews from "./pages/AdminReviews/AdminReviews";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage/LoginPage";
import CategoryAdminPage from "./pages/categories/CategoryAdminPage";

const menuRoutes: MenuRoute[] = [
  { label: "Создать продукт", path: "/product-create", icon: <FileAddOutlined /> },
  { label: "Сертификаты", path: "/certificates", icon: <FileTextOutlined /> },
  { label: "Промо-акции", path: "/promotions", icon: <GiftOutlined /> },
  { label: "Отзывы", path: "/review", icon: <FileTextOutlined /> }, 
  { label: "Категории", path: "/categories", icon: <AppstoreOutlined /> }, 

];

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <PrivateRoute>
              <SidebarLayout menuRoutes={menuRoutes} />
            </PrivateRoute>
          }
        >
          <Route path="/product-create" element={<ProductCreatePage />} />
          <Route path="/certificates" element={<CertificateAdmin />} />
          <Route path="/promotions" element={<PromotionAdmin />} />
          <Route path="/review" element={<AdminReviews />} />
          <Route path="/categories" element={<CategoryAdminPage />} />

          <Route path="*" element={<div>Выберите раздел</div>} />
          
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
